import { useI18n } from 'vue-i18n';
import type { TranslationKey } from '@/i18n';
import i18n from '@/i18n';
import type { LocalizedString } from '@shared-types/scenario-definition';
import { st } from '@/i18n/localized-string';
import { isNullable } from './nullability-helpers';

/**
 * Resolves a TranslationKey or LocalizedString to a string value.
 * Uses i18n.global.t directly so it is safe to call from computed properties
 * and other non-setup contexts (e.g. during language switches).
 */
export function resolveTranslationKey(key?: TranslationKey | LocalizedString): string {
    if (isNullable(key)) return '';

    if (typeof key === 'string') {
        return i18n.global.t(key);
    }

    return st(key);
}

export function getLanguages() {
    const { t } = useI18n();

    return [
        {
            value: 'en',
            text: t('language.en'),
        },
        {
            value: 'de',
            text: t('language.de'),
        },
        {
            value: 'fr',
            text: t('language.fr'),
        },
        {
            value: 'es',
            text: t('language.es'),
        },

        {
            value: 'it',
            text: t('language.it'),
        },

        {
            value: 'pt',
            text: t('language.pt'),
        },

        {
            value: 'hi',
            text: t('language.hi'),
        },
    ];
}
